module.exports = __webpack_public_path__ + "static/media/offRoadnew.d8a311df.png";